"use client";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import MobileHeader from "@/components/MobileHeader";
import { DownloadModal } from "@/components/DownloadModal";
import classNames from "classnames";
import { usePathname } from "next/navigation";
import { WebsiteContext, WebsiteContextKey } from "./WebsiteContext";
import React, { useMemo, useState, useEffect } from "react";
import "./styles.scss";
interface IProps {
  children?: React.ReactNode;
}

export default function Content(props: IProps) {
  const pathname = usePathname();

  const isHomePage = pathname === "/";
  const { children } = props ?? {};
  // useEffect(() => {
  //   enableScroll();
  //   // window.addEventListener("load", enableScroll);
  //   const handleBeforeUnload = () => {
  //     setTimeout(() => {
  //       window.scrollTo(0, 0);
  //     }, 10);
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     // window.removeEventListener("load", enableScroll);
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  const homeClass = useMemo(() => {
    return classNames({
      "fellou-layout-content": true,
      "fellou-layout-layout-light": true,
    });
  }, []);

  const [adopterModalStatus, setAdopterModalStatus] = useState(false);

  useEffect(() => {
    // 安全地获取 URL 参数
    try {
      if (typeof window !== "undefined") {
        const params = new URLSearchParams(window.location.search);
        const apply = params.get("apply");
        setAdopterModalStatus(apply === "1");
      }
    } catch (error: unknown) {
      console.warn("Failed to parse URL parameters:", error);
    }
  }, []);

  const onSaveWebsiteCallback = async (key: WebsiteContextKey, value: unknown) => {
    switch (key) {
      case WebsiteContextKey.updateAdopterModalStatus:
        setAdopterModalStatus(value as boolean);
        break;

      default:
        break;
    }
  };

  return (
    <>
      <WebsiteContext.Provider
        value={{
          adopterModalStatus,
          onSaveWebsiteCallback,
        }}
      >
        <div className="desktop-only">
          <Header />
        </div>
        <div className="mobile-only">
          <MobileHeader />
        </div>
        <div className={homeClass}>
          {children}
          {!isHomePage && <Footer />}
        </div>

        <DownloadModal
          open={adopterModalStatus}
          setOpen={(value) => {
            setAdopterModalStatus(value);
          }}
        />
      </WebsiteContext.Provider>
    </>
  );
}
